import { createContext, useContext } from 'react';

import { Filters } from '@work4all/models/lib/DataProvider';

interface TablePrefilterState {
  prefilter: Filters;
}

const Context = createContext<TablePrefilterState | null>(null);
export const TablePrefilterProvider = Context.Provider;

export const useTablePrefilterContext = () => {
  const context = useContext(Context);

  if (!context)
    return {
      prefilter: [],
    };
  return context;
};
